const cards = [
  {
    title: '暗夜追踪',
    tag: '悬疑动作',
    desc: '夜幕降临，一场跨越三个城市的追踪与反追踪正式展开。高智商罪犯与王牌警探的终极对决。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20noir%20crime%20thriller%20scene%20with%20detective%20silhouette%20against%20neon%20lit%20rainy%20city%20street%20at%20night%2C%20cinematic%20composition%20with%20warm%20streetlight%20reflections%20on%20wet%20pavement%2C%20mysterious%20atmosphere%2C%20film%20grain%20texture%2C%20amber%20and%20shadow%20tones&width=800&height=600&seq=card-movie-01&orientation=landscape',
    tagColor: 'bg-primary-100 text-primary-700',
    icon: 'ri-movie-2-line',
  },
  {
    title: '星海迷途',
    tag: '科幻史诗',
    desc: '人类星际移民舰队在深空遭遇未知信号，一艘失联百年的飞船突然出现在雷达上，真相令人窒息。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20spacecraft%20floating%20in%20deep%20cosmos%20with%20nebulae%20and%20distant%20stars%2C%20cinematic%20wide%20shot%20of%20futuristic%20spaceship%20with%20warm%20interior%20lights%20glowing%20against%20dark%20space%2C%20atmospheric%20and%20majestic%20composition&width=800&height=600&seq=card-movie-02&orientation=landscape',
    tagColor: 'bg-accent-100 text-accent-700',
    icon: 'ri-rocket-2-line',
  },
  {
    title: '午夜食堂',
    tag: '温情美食',
    desc: '城市深夜不打烊的小餐馆里，每位食客都有自己的故事。一碗热汤面，温暖整座城市的夜归人。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20late-night%20restaurant%20interior%20with%20warm%20steaming%20noodle%20bowls%20on%20wooden%20counter%2C%20soft%20amber%20lighting%20from%20hanging%20lanterns%2C%20intimate%20atmosphere%20with%20steam%20rising%2C%20Japanese%20izakaya%20style%20with%20cinematic%20depth%20of%20field&width=800&height=600&seq=card-movie-03&orientation=landscape',
    tagColor: 'bg-secondary-100 text-secondary-700',
    icon: 'ri-restaurant-line',
  },
  {
    title: '极速追击',
    tag: '犯罪惊悚',
    desc: '一名退役赛车手被迫卷入地下赛车集团的阴谋，在午夜的城市高架上演生死时速。',
    img: 'https://readdy.ai/api/search-image?query=High-speed%20car%20chase%20on%20elevated%20highway%20at%20night%20with%20city%20lights%20blurring%20past%2C%20cinematic%20motion%20blur%20effect%2C%20warm%20streetlamp%20glow%20reflecting%20on%20wet%20asphalt%2C%20intense%20action%20atmosphere%20with%20dramatic%20lighting&width=800&height=600&seq=card-movie-04&orientation=landscape',
    tagColor: 'bg-primary-100 text-primary-700',
    icon: 'ri-speed-up-line',
  },
  {
    title: '月光恋人',
    tag: '浪漫爱情',
    desc: '两个习惯熬夜的人在午夜电影院相遇，从陌生到熟悉，银幕光影交错间悄然萌生的爱情故事。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20night%20scene%20of%20two%20people%20sitting%20in%20empty%20cinema%20with%20warm%20projector%20light%20beam%20cutting%20through%20darkness%2C%20soft%20golden%20glow%20illuminating%20their%20profiles%2C%20intimate%20atmosphere%2C%20vintage%20movie%20theater%20aesthetic&width=800&height=600&seq=card-movie-05&orientation=landscape',
    tagColor: 'bg-accent-100 text-accent-700',
    icon: 'ri-heart-line',
  },
  {
    title: '暗网迷踪',
    tag: '纪录写实',
    desc: '深入暗网世界，揭开网络黑产链条背后的惊人真相。一部让你重新认识互联网安全的硬核纪录片。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20digital%20interface%20with%20glowing%20code%20lines%20on%20multiple%20screens%20in%20dimly%20lit%20room%2C%20cyberpunk%20atmosphere%20with%20warm%20monitor%20glow%2C%20investigative%20journalism%20aesthetic%2C%20documentary%20style%20composition&width=800&height=600&seq=card-movie-06&orientation=landscape',
    tagColor: 'bg-secondary-100 text-secondary-700',
    icon: 'ri-shield-keyhole-line',
  },
  {
    title: '深夜脱口秀',
    tag: '热门综艺',
    desc: '全网最敢说的深夜脱口秀，犀利吐槽搭配精彩嘉宾访谈，每周五凌晨准时上线陪你度过不眠夜。',
    img: 'https://readdy.ai/api/search-image?query=Late%20night%20talk%20show%20studio%20set%20with%20warm%20stage%20lighting%2C%20comfortable%20armchairs%20and%20coffee%20table%2C%20cozy%20broadcast%20atmosphere%20with%20brick%20wall%20backdrop%2C%20professional%20television%20production%20aesthetic%20with%20soft%20golden%20spotlights&width=800&height=600&seq=card-movie-07&orientation=landscape',
    tagColor: 'bg-primary-100 text-primary-700',
    icon: 'ri-chat-smile-2-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            每日精选高分佳作，夜猫子们都在看的午夜好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.slice(0, 7).map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] w-full relative overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={`${card.title} - ${card.tag}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${card.tagColor}`}>
                    <i className={`${card.icon} text-[10px]`}></i>
                    {card.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}